import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslatePipe } from '@ngx-translate/core';

export interface UpdateBannerData {
  /** Translation key of the body text. */
  bodyKey: string;
  /** Optional "Mitä uutta?" link (major update only). */
  showWhatsNew?: boolean;
}

/**
 * Calm "an update is available" notice. Opened through MatSnackBar.openFromComponent by
 * UpdateNoticeService: bottom, non-blocking, dismissible. "Päivitä nyt" resolves the
 * snackbar's onAction(); "Myöhemmin" / close dismiss it without an action.
 */
@Component({
  selector: 'ri-update-banner',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, TranslatePipe],
  templateUrl: './update-banner.component.html',
  styleUrl: './update-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateBannerComponent {
  readonly data = inject<UpdateBannerData>(MAT_SNACK_BAR_DATA);
  private readonly ref = inject<MatSnackBarRef<UpdateBannerComponent>>(MatSnackBarRef);

  updateNow(): void {
    this.ref.dismissWithAction();
  }

  later(): void {
    this.ref.dismiss();
  }
}
